<template>
  <div class="privacyintro">
    <b-container>
      <b-row class="privacy-intro-row">
        <b-col lg="6" md="12" sm="12" class="left">
          <LeftContent id="left" :heading="heading" :paragraph="paragraph" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import LeftContent from "./common/leftContent";
export default {
  name: "Privacyintro",
  props: ["heading", "paragraph"],
  components: {
    LeftContent,
  },
};
</script>
<style scoped>
.left {
  padding-left: 0;
}
/*
.privacy-intro-row {
  height: 100%;
  
 transform: translateY(20%);
}

@media screen and (max-width: 700px) {
  .privacyintro {
   
  }
  .privacy-intro-row {
    height: 100%;
   
  }
}
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
 
   .container {
    backdrop-filter: blur(4px);
  }
}
@media (max-width: 767px) {
  .left {
    padding-left: 8px;
  }
  .container {
    backdrop-filter: blur(4px);
  }
}

@media (max-width:480px){
  .left {
        padding-left: 8px;
        padding-top: 56px;
    padding-bottom: 15px
  }
  .container {
    backdrop-filter: blur(4px);
  }
}
</style>
